import { hasCapability, type User } from "../base";

export const contractorDocumentExemption = {
  create: (user: User) => hasCapability(user, "contractorDocumentExemption.create"),
  delete: (user: User) => hasCapability(user, "contractorDocumentExemption.delete"),
};
